module.exports = __webpack_public_path__ + "img/campaign_select_grand_campaign.408936b9.png";